import React from "react";
import { Element } from "react-scroll";
import { useSelector } from "react-redux";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Status from "./Status";
import ContactEnquiry from "./ContactEnquiry";
import "./contact.css";

const photos = ["bullsblood.jpg", "cress2.jpg", "redkale.jpg", "sango.jpg"];
const image = (file) => `https://firebasestorage.googleapis.com/v0/b/vert-farm-api.appspot.com/o/web%2Fimg%2F${file}?alt=media`;

export default function ContactOuter() {
  const language = useSelector((state) => state.app.language);
  const sv = language === 0;

  return <section className="ContactOuter">
    <div className="ContactLandingStatus FarmLandingContainer">
      <Status />
    </div>

    <div className="ContactLandingPhotoStrip" aria-hidden="true">
      {photos.map((file) => <img key={file} src={image(file)} alt="" loading="lazy" />)}
    </div>

    <Element name="farm/contact" className="ContactLandingAnchor FarmLandingContainer" id="farm-contact">
      <header className="FarmLandingSectionHeading ContactLandingHeading">
        <h2>{sv ? "KONTAKTA OSS" : "CONTACT US"}</h2>
      </header>
    </Element>

    <div className="ContactLandingDetails FarmLandingContainer">
      <div className="ContactLandingAddress">
        <h3>VERT.farm Sverige AB</h3>
        <address>Björkallén 36<br />313 33 Oskarström<br />Sweden</address>
        <a href="https://maps.google.com/?q=Bj%C3%B6rkall%C3%A9n+36,+313+33+Oskarstr%C3%B6m" target="_blank" rel="noopener noreferrer">{sv ? "Visa vägbeskrivning" : "Get directions"}<ArrowForwardIcon /></a>
      </div>
      <div className="ContactLandingMap"><iframe title={sv ? "Karta till VERT.farm" : "Map to VERT.farm"} loading="lazy" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCVCOdSlc7E6mjBRxzZACKF4UxGZz3Z8Ws&q=björkallén+36,oskarström" /></div>
    </div>

    <section className="ContactHomeEnquiry" aria-labelledby="contact-enquiry-title">
      <div className="ContactHomeEnquiryCopy">
        <h2 id="contact-enquiry-title">{sv ? "Vad kan vi hjälpa dig med?" : "How can we help?"}</h2>
        <p>{sv
          ? "Nyfiken på våra produkter, en leverans eller ett samarbete? Berätta vad du har i åtanke så hör vi av oss."
          : "Curious about our products, a delivery or working together? Tell us what you have in mind and we'll get back to you."}</p>
      </div>
      <ContactEnquiry language={language} />
    </section>

    <footer className="ContactLandingFooter FarmLandingContainer">
      <span>VERT<span>.farm</span></span>
      <div><a href="https://www.facebook.com/vert.farm/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FacebookIcon /></a><a href="https://www.instagram.com/vert.farm/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramIcon /></a></div>
    </footer>
  </section>;
}
